<template>
    <div :class="['visual-preloader', {'is-hidden': !state}]">
        <div class="loader">
            <div class="loader__item"></div>
            <div class="loader__item"></div>
            <div class="loader__item"></div>
        </div>
    </div>
</template>
<style lang='scss'>
    @import "./Preloader.scss";
    @import "~components/loader/loader.scss";
</style>
<script>
import {mapGetters} from 'vuex';

export default {computed: {...mapGetters({state: 'GET_IS_PROCESSING'})}};
</script>
